import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import CalendarTodayIcon from '@mui/icons-material/CalendarToday'

import { StyledDialog, StyledDialogContent, FlexEndContainer, FlexColumn, WhiteBGContainer } from '../styles/Containers'
import { BoldFormTitle } from '../styles/Text'
import { Calendar } from '../styles/Calendar'
import Button, { IconOnlyButton, SecondaryButton } from './Button'

function CalendarDateButton({ onConfirm = () => {}, title = 'Date', initialValue, disableFuture = true, disabled = false }) {
  const [isVisible, setIsVisible] = useState(false)
  const [date, setDate] = useState(initialValue)

  const isMounted = useRef(true)
  useEffect(() => {
    return () => {
      isMounted.current = isVisible
    }
  }, [])

  const handleOpen = () => setIsVisible(true)
  function handleClose() {
    setIsVisible(false)
    setDate(initialValue)
  }
  function handleConfirm() {
    setIsVisible(false)
    onConfirm(date)
  }

  return (
    <>
      <IconOnlyButton onClick={handleOpen} aria-label="Select date" disabled={disabled}>
        <CalendarTodayIcon />
      </IconOnlyButton>
      <StyledDialog open={isVisible} onClose={handleClose} keepMounted={false}>
        <StyledDialogContent>
          <WhiteBGContainer padding="30px">
            <FlexColumn>
              <BoldFormTitle>{title}</BoldFormTitle>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Calendar value={date} onChange={newDate => setDate(newDate)} disableFuture={disableFuture} />
              </LocalizationProvider>
              <FlexEndContainer>
                <SecondaryButton onClick={handleClose}>Cancel</SecondaryButton>
                <Button onClick={handleConfirm}>OK</Button>
              </FlexEndContainer>
            </FlexColumn>
          </WhiteBGContainer>
        </StyledDialogContent>
      </StyledDialog>
    </>
  )
}

CalendarDateButton.propTypes = {
  onConfirm: PropTypes.func,
  title: PropTypes.string,
  initialValue: PropTypes.instanceOf(Date).isRequired,
  disableFuture: PropTypes.bool
}

export default CalendarDateButton
